export default __webpack_public_path__ + "static/media/b_speaking_large.fa55292a.png";